<div class="upload-dialog" *ngIf="isCustomUiChange; else oldUIDesign">
  <div class="dialog-header header">
    <div class="header-title">
      <mat-icon>upload_file</mat-icon>
      <span>File Upload</span>
    </div>
    <button mat-icon-button class="close-btn" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>File Type</mat-label>
      <mat-select [(ngModel)]="selectedImageCode">
        <mat-option *ngFor="let fileType of fileTypes" [value]="fileType.ImageCode">
          {{ fileType.ImageDescription }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="file-upload-section">
      <label class="file-label">
        Select File <span class="required">*</span>
      </label>
      <input type="file" (change)="handleFiles($event)" class="file-input">
      <p class="file-help-text">File Type Supported: {{ acceptedFileTypesDisplay }} | Max size: {{ maxFileSizeMb }} MB</p>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Document Description</mat-label>
      <input matInput maxlength="250" [(ngModel)]="description">
    </mat-form-field>
  </div>

  <div class="dialog-footer">
    <button mat-raised-button color="primary" [disabled]="!selectedImageCode || !file || !result || uploading" (click)="uploadDoc()">
      <mat-icon>cloud_upload</mat-icon>
      Upload
    </button>
  </div>
</div>

<ng-template #oldUIDesign>
  <div style="float: right; top: -5px; right: -5px; color: white">
    <button mat-icon-button [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <h1 mat-dialog-title class="header" style="padding: 0.5vw; font-size: 1.2vw; color:white">
    File Upload
  </h1>
  <div mat-dialog-content>
    <mat-card style="width: 40vw;">
      <mat-card-content>
        <mat-form-field appearance="outline" class="formfield-half">
          <mat-label>File Type</mat-label>
          <mat-select [(ngModel)]="selectedImageCode">
            <mat-option *ngFor="let fileType of fileTypes" [value]="fileType.ImageCode" style="font-size: 11px;">
              {{ fileType.ImageDescription }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!--  <mat-form-field  appearance="outline" class="formfield-half"> -->
        <!--   <mat-label>Select File:</mat-label> -->
        <input type="file" (change)="handleFiles($event)">
        <p class="file-help-text">File Type Supported: {{ acceptedFileTypesDisplay }} | Max size: {{ maxFileSizeMb }} MB</p>
        <mat-form-field appearance="outline">
          <mat-label>Document Description</mat-label>
          <input type="text" matInput [(ngModel)]="description">
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions>
        <button mat-button [disabled]="!selectedImageCode || !file || !result || uploading" (click)="uploadDoc()">Upload</button>
      </mat-card-actions>
    </mat-card>
  </div>
</ng-template>